import { getKey, Key, Properties, TravelType } from '../../common';
import { Component, h } from 'preact';
import Selector from '../../common/Selector/Selector';
import { withStyles } from '../../style';
import * as appStyles from '../../assets/global.scss';
import * as styles from './TravelTypeSelector.scss';
import { BookingState, connectStore } from '../../store';
import { stopPropagation } from '../../utils';
import { TravelTypeModal } from './TravelTypeModal/TravelTypeModal';
import { FinText } from '../../i18n';
import Tooltip from '../../common/Tooltip/Tooltip';
import { withText } from 'preact-i18n';

export interface TravelTypeSelectorProps extends Properties {}

interface StoreProps {
  travelType: TravelType;
}

interface TranslationProps {
  multiCityTooltipUrl: string;
}

type EffectiveProps = TravelTypeSelectorProps & StoreProps & TranslationProps;

const mapStateToProps = ({ selection: { travelType } }: BookingState): StoreProps => ({ travelType });
@withStyles(styles, appStyles)
@withText({
  multiCityTooltipUrl: 'multiCityTooltip.link.url.url',
})
@connectStore({ mapStateToProps })
export default class TravelTypeSelector extends Component<TravelTypeSelectorProps> {
  openModal = (e: Event): void => {
    stopPropagation(e);
    const { disabled } = this.props;
    if (!disabled) {
      this.context.modal.showModal(<TravelTypeModal />);
    }
  };

  handleKeyUp = (e: KeyboardEvent): void => {
    const key: Key = getKey(e);
    if (key === Key.ENTER || key === Key.SPACE) {
      this.openModal(e);
    }
  };

  render({ travelType, multiCityTooltipUrl }: EffectiveProps): h.JSX.Element {
    return (
      <Selector class={this.props.class} onClick={this.openModal} onKeyUp={this.handleKeyUp}>
        <div class="grey-600-text font-body-1 regular-type">
          <FinText id="travelType.label" />
        </div>

        <div className="flex flex--space-between">
          <div className={`medium-type font-heading-5 nordic-blue-900-text`}>
            <FinText id={`travelType.${travelType}`} />
          </div>
          {travelType === TravelType.MULTI_CITY && (
            <div className="bw-multicity-info">
              <Tooltip
                iconName="help-block"
                placement="top"
                url={multiCityTooltipUrl}
                description="multiCityTooltip.description"
                urlText="multiCityTooltip.linkText"
              />
            </div>
          )}
        </div>
      </Selector>
    );
  }
}
